export default __webpack_public_path__ + "static/events-dark-7966210868f970d006c00e041ff4b4a9.png";